export const menuKey = {
  pendingOrders: 'pendingOrders',
  provisionOrders: 'provisionOrders',
  faultOrders: 'faultOrders',
  totalAccount: 'totalAccount',
  pendingTicket: 'pendingTicket',
  pendingLeads: 'pendingLeads',
};
